import { Reveal } from '../ui/Reveal';
import art from './Art.module.css';
import styles from './Skyline.module.css';

// Line drawing of the Detroit riverfront: Ambassador Bridge, Penobscot, RenCen, Guardian.
const BASE = 220;

// Suspension cable between the bridge towers: y = 112 + 156·t(1−t)
const hangers = Array.from({ length: 11 }, (_, i) => {
  const x = 102 + i * 12;
  const t = (x - 90) / 140;
  return `M${x} ${(112 + 156 * t * (1 - t)).toFixed(1)} V196`;
}).join(' ');

const renFloors = Array.from({ length: 9 }, (_, i) => `M512 ${80 + i * 16} H548`).join(' ');

const shapes = [
  // Ambassador Bridge
  { d: 'M10 196 H310', d0: 0 },
  { d: 'M86 220 V112 H94 V220 M226 220 V112 H234 V220', d0: 150 },
  { d: 'M20 192 Q60 150 90 112 Q160 190 230 112 Q260 150 300 192', d0: 400, accent: true },
  { d: hangers, d0: 900, faint: true },
  // Low-rise fill
  { d: 'M318 220 V172 H352 V160 H372 V220', d0: 300 },
  // Penobscot Building
  { d: 'M380 220 V120 H390 V90 H398 V70 H422 V90 H430 V120 H440 V220 M410 70 V42', d0: 500 },
  // Renaissance Center: central cylinder and two flanking towers
  { d: 'M510 220 V64 A20 6 0 0 1 550 64 V220 M510 64 A20 6 0 0 0 550 64', d0: 700 },
  { d: 'M478 220 V112 A14 4 0 0 1 506 112 V220 M554 220 V112 A14 4 0 0 1 582 112 V220', d0: 850 },
  { d: renFloors, d0: 1200, faint: true },
  // Guardian Building
  { d: 'M640 220 V150 H650 V120 H660 V98 Q670 84 680 98 V120 H690 V150 H700 V220', d0: 950 },
  // Low-rise fill
  { d: 'M596 220 V160 H632 V220 M708 220 V178 H760 V190 H790 V220', d0: 1050 },
];

export function Skyline() {
  return (
    <Reveal className={styles.skyline} aria-hidden="true">
      <svg className={art.svg} viewBox="0 0 800 260" focusable="false" preserveAspectRatio="xMidYMax meet">
        <path d={`M0 ${BASE} H800`} pathLength="1" className={`${art.draw} ${art.faint}`} />
        {shapes.map(({ d, d0, accent, faint }) => (
          <path
            key={d}
            d={d}
            pathLength="1"
            className={`${art.draw} ${accent ? art.accent : ''} ${faint ? art.faint : ''}`}
            style={{ '--d': `${d0}ms` }}
          />
        ))}
        {/* Penobscot beacon */}
        <circle cx="410" cy="38" r="3.5" className={styles.beacon} />
        {/* Detroit River */}
        <g className={styles.river}>
          <path d="M0 232 H800" />
          <path d="M40 242 H760" />
          <path d="M120 252 H680" />
        </g>
        <text x="800" y="16" textAnchor="end" className={`${art.label} ${art.fade}`} style={{ '--d': '1600ms' }}>
          42.33° N · 83.05° W
        </text>
      </svg>
    </Reveal>
  );
}
